import { GetProp, Upload, UploadFile, UploadProps } from "antd";
import { upload } from "@/utils/file/upload";

import { FC, useState } from "react";
import WMSAvatar, { IWMSAvatar } from "../WMSAvatar";
import { LoadingOutlined } from "@ant-design/icons";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

type IAvatarUpload = {
  onChange: (id: string) => void;
} & IWMSAvatar

const AvatarUpload:FC<IAvatarUpload> = (avatarProps) => {

  const [loading, setLoading] = useState(false);

  const onPreview = async (file: UploadFile) => {
    let src = file.url as string;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as FileType);
        reader.onload = () => resolve(reader.result as string);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onChange: UploadProps['beforeUpload'] = (file) => {
    setLoading(true)
    upload({name: file.name, size: file.size, file})
      .then(uploadedFile => {
        avatarProps.onChange(uploadedFile?.id ?? '')
      })
      .finally(() => setLoading(false))

    return false;
  };

  return (
    <Upload
      listType="picture-circle"
      onPreview={onPreview}
      beforeUpload={onChange}
      accept="image/*"
      showUploadList={false}
    >
      {loading ? <LoadingOutlined /> : <WMSAvatar {...avatarProps} tooltip={false} style={{ width: "100%", height: '100%' }} />}
    </Upload>
  )
}

export default AvatarUpload;